import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';

@MergeSchema({
    entity: ActivityEntityName.Opportunity
})
export class OpportunityMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    name: string;

    @MergeField()
    opportunityNumber: string;

    @MergeField()
    stage: string;

    @MergeField()
    description: string;

    @MergeField()
    amount: string;

    @MergeField()
    probability: string;

    @MergeField()
    source: string;

    @MergeField()
    jobType: string;

    @MergeField()
    tags: string;

    @MergeField()
    createdAt: string;

    @MergeField()
    expectedClose: string;

    @MergeField()
    lastActivity: string;

    @MergeField()
    timezone: string;

    [key: string]: string;
}

export const OpportunityMergeSchema = getSchema(OpportunityMergeData);